import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import promoMobileBG from 'assets/img/background/promo_mobile.webp';
import promoMainDesktop from 'assets/img/background/promo_main_desktop.webp';
import promoBubblesDesktop from 'assets/img/background/promo_bubbles_desktop.webp';

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      color: theme.palette.common.white,
      fontSize: 15,
      lineHeight: 1.2,
      minHeight: 650,
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        minHeight: 1000
      }
    },
    container: {
      position: 'relative',
      paddingTop: 20,
      paddingBottom: 20,
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      backgroundImage: `url(${promoMobileBG})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center top 145px',
      backgroundSize: '370px auto',
      [theme.breakpoints.up('md')]: {
        backgroundImage: `url(${promoMainDesktop}), url(${promoBubblesDesktop}) `,
        backgroundRepeat: 'no-repeat, no-repeat',
        backgroundPosition: 'right 30px top 120px, left top 120px',
        backgroundSize: '40% auto, 60% auto'
      }
    },
    content: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        alignItems: 'flex-start',
        paddingTop: 185,
        paddingBottom: 55,
        maxWidth: 674
      }
    },
    title: {
      fontWeight: 700,
      fontSize: 26,
      lineHeight: 1,
      marginBottom: 10,
      [theme.breakpoints.up('md')]: {
        fontSize: 58,
        lineHeight: 1,
        marginBottom: 14
      }
    },
    desc: {
      fontWeight: 500,
      fontSize: 13,
      lineHeight: 1.5,
      '& strong': {
        fontWeight: 700
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 27
      }
    },
    ladder: {
      [theme.breakpoints.up('md')]: {
        position: 'absolute',
        right: '10%',
        top: 40
      }
    },
    button: {
      position: 'relative',
      marginTop: 'auto',
      maxWidth: 328,
      width: '100%',
      [theme.breakpoints.up('md')]: {
        marginTop: 25
      }
    }

  }), { name: 'Promo' }
);
